
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerDataSource } from 'angular2-smart-table';
import { HttpService } from './common/http.service';
import { InternalDoc, InternalDocData } from '../interfaces/internal-doc';
import { HttpParams } from '@angular/common/http';
import { get, has, isArray, isNull, isObject, isUndefined, mapValues, omit, pickBy } from 'lodash';
import { User } from '../interfaces/auth/users';
import { prepRecordForApi } from '../utils/utils.service';
@Injectable()
export class InternalDocService extends InternalDocData {
  private readonly url: string;

  constructor(
    private api: HttpService,
  ) {
    super();
    this.url = 'internal-documents';

  }

  get gridDataSource(): ServerDataSource {
    return this.api.getServerDataSource(`${this.api.API_BASE_URL}/${this.url}?populate=*`);
  }

  list(pageNumber: number, pageSize: number, query: string = '' ): Observable<InternalDoc[]> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    if (pageSize > 0) {
      params = params.append('limit', `${pageSize}`);
    }

    if (pageNumber > 0) {
      params = params.append('offset', `${(pageNumber - 1) * pageSize}`);
    }

    // If you have filters, sorts, etc. in query, convert them to v5 format
    // Example: ?where[title][$contains]=foo&order=createdAt:desc
    if (query) {
      // You may need to parse and append query params here
      // For now, assume query is already in v5 format
      params = params.append('where', query);
    }

    return this.api.get(this.url, { params }).pipe(map(res => {
      return res.data || res;
    }));
  }
  

  listAll(): Observable<InternalDoc[]> {
    let params: HttpParams = new HttpParams()
      .append('limit', '-1')
      .append('offset', '0');

    params = params.append('populate', '*');

    return this.api.get(this.url, { params }).pipe(map(res => {
      return res.data || res;
    }));
  }

  get(id: any): Observable<InternalDoc> {
    return this.api.get(`${this.url}/${id}`, {
      params: new HttpParams().append('populate', '*')
                              // .append('populate[internaldocs][populate]', '*')
    }).pipe(map(res => res.data || res));
  }

  create(record: InternalDoc): Observable<InternalDoc> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    const recordToSave = prepRecordForApi(record);

    return this.api.post(this.url, {data: recordToSave}, { params })
      .pipe(map(res => {
        return res.data;
      }));
  }


  update(record: InternalDoc | any): Observable<InternalDoc> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    const recordToSave = prepRecordForApi(record);

    return this.api.put(`${this.url}/${record.documentId}`, {data: recordToSave}, { params })
      .pipe(map(res => {
        return res.data;
      }));
  }

  delete(id: any): Observable<any> {
    return this.api.delete(`${this.url}/${id}`);
  }

  chat(message: any): Observable<string> {
    return this.api.post(`${this.url}/chat`, { message: message}).pipe(map((res): any => {
      return String(res.answer);
    }));
  }
}
